PJQ.models.budget.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    parseNumberFormat: function (numberFormat, project, additionalData) {
        let result = '';

        _.each(numberFormat, _.bind(function (token) {
            if (token.isText)
                result += token.label;
            else if (token.token === 'today')
                result += this.parseDateFormatToken(new Date(), token.dateFormatId);
            else if (token.token === 'project.projectId')
                result += project.get('projectId').toString();
            else if (token.token === 'project.startDate')
                result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false), token.dateFormatId);
            else if (token.token === 'counter')
                result += additionalData.counter.toString().padStart(4, '0');
            else if (token.token.startsWith('fieldValue')) {
                let fieldNumber = parseInt(token.token.substr(10));
                _.each(PJQ.app.session.project.customFields.models, _.bind(function (customField) {
                    if (customField.get('fieldNumber') === fieldNumber) {
                        _.each(PJQ.app.session.project.get('customFields'), _.bind(function (fieldValue) {
                            if (fieldValue.fieldNumber === fieldNumber) {
                                switch (customField.get('fieldType')) {
                                    case PJQ.constants.customFields.fieldTypes.TEXT:
                                    case PJQ.constants.customFields.fieldTypes.INT:
                                        result += fieldValue.value.toString();
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                                        _.each(customField.get('choices'), _.bind(function (choice) {
                                            if (choice.id === fieldValue.value)
                                                result += choice.choiceName;
                                        }, this));
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATE:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, false), token.dateFormatId);
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, true), token.dateFormatId);
                                        break;
                                }
                            }
                        }, this));
                    }
                }, this));
            }
        }, this));

        return result.replaceAll(' ', '');
    },
    parseDateFormatToken: function (input, dateFormatId) {
        let result = null;

        switch (dateFormatId) {
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.DD:
                result = input.getDate().toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MM:
                result = (input.getMonth() + 1).toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YY:
                result = input.getFullYear().toString().substr(2);
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YYYY:
                result = input.getFullYear().toString();
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MMDDYYYY:
                //PJQ.helpers.dateHelpers.getDateString(startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD, false) + ' 00:00:00');
                result = PJQ.helpers.dateHelpers.getDateString(input, PJQ.helpers.dateHelpers.dateFormats.URL_DATE, false).replaceAll('-', '');
                break;
        }

        return result;
    }
});